import Big from 'big.js'
import { atomsWithQuery } from 'jotai-tanstack-query'

// INFO: Raw data response models
export type RawApyData = {
  apy: number
  assetsApy: { [asset: string]: number }
}
export type RawApy = {
  data: RawApyData
}

// INFO: Parsed data response models
export type ApyData = {
  apy: Big
}

export type ApyReturn = ReturnType<typeof atomsWithQuery<ApyData>>

export type ApyRequest = ApyReturn['0']
export type ApyDispatch = ApyReturn['1']

export const parseApyResponse = async <T>(response: RawApyData): Promise<T> => {
  return { apy: Big(response.apy) } as T
  // INFO: add assetsApy if needed
}
